<template>
  <van-popup
    class="attachment-popup"
    :value="detailsVisible"
    position="bottom"
    closeable
    @click-close-icon="close"
    @click-overlay="close"
  >
    <div class="popup-wrapper">
      <div class="popup-title">附件信息</div>
      <div class="popup-body">
        <hi-attachment :attach-list="attachList"></hi-attachment>
      </div>
    </div>
  </van-popup>
</template>

<script>
export default {
  name: 'NewProductPricingAttachmentDialog',
  props: {
    attachList: {
      type: Array,
      default: () => []
    },
    detailsVisible: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    close() {
      this.$emit('close-details-dialog')
    }
  }
}
</script>

<style lang="scss" scoped>
.attachment-popup {
  height: 90vh;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  overflow: hidden;
}
.popup-wrapper {
  height: 90vh;
  display: flex;
  flex-direction: column;
  position: relative;
}
.popup-title {
  text-align: center;
  padding: 0 40px;
  height: 46px;
  line-height: 46px;
  font-size: 17px;
  font-weight: 500;
  color: #333;
}
.popup-body {
  flex: 1;
  overflow-y: auto;
  box-sizing: border-box;
  padding: 0 10px;
  background: #f7f8fa;
}
.attachment-popup :deep(.van-popup__close-icon) {
  top: 11px;
}
:deep(.van-cell) {
  margin: 10px 5px;
  border-radius: 6px;
  background: #fff;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.06);
  padding: 13px 16px;
}
:deep(.van-cell::after) {
  border-bottom: none;
}
</style>
